import axios from 'axios'
import { CONFIGS } from '../configs'

export default {
  list(page, search) {
    if(page === undefined) page = 1
    if(search === undefined || search==='') search = ''; else search = '&search='+search
    return axios.get(CONFIGS.API_SERVER + '/publication/?ordering=-id&page=' + page + search)
  },
  get(id) {
    return axios.get(CONFIGS.API_SERVER + '/publication/' + id)
  },
  partner() {
    return axios.get(CONFIGS.API_SERVER + '/api/partnership/')
  },
  get_status() {
    return axios.get(CONFIGS.API_SERVER + '/api/get_status/')
  },
  create(data) {
    return axios.post(CONFIGS.API_SERVER + '/publication/', data)
  },
  update(data, id) {
    return axios.put(CONFIGS.API_SERVER + '/publication/' + id + '/', data)
  },
  remove(id) {
    return axios.delete(CONFIGS.API_SERVER + '/publication/' + id)
  },
  price_refactor(percentage) {
    return axios.post(CONFIGS.API_SERVER + '/api/price_refactor/', percentage)
  }
}
